import React from "react";
import { TimeLine } from "./TimeLine";

export function StartScreen() {
    return (<div className="p-grid">
        <div className="p-col-10 p-offset-1">
            <TimeLine />
        </div>

    </div>)
}